import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import "@/resources/globals.css";
import "@/lib/language/i18n";

import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import Main from './main';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <Suspense fallback={<></>}>
            <Main />
        </Suspense>
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
